import React from 'react';

const MEDALS = { 1: '🥇', 2: '🥈', 3: '🥉' };
const LABELS = { 1: 'מקום ראשון', 2: 'מקום שני', 3: 'מקום שלישי' };

export const TournamentPodium = ({ tournament }) => {
  if (tournament.status !== 'completed' || !tournament.podium?.length) return null;

  return (
    <div
      className="rounded-xl overflow-hidden border border-amber-200/70 dark:border-amber-500/30 bg-gradient-to-l from-amber-50 via-yellow-50 to-orange-50 dark:from-amber-900/20 dark:via-slate-800 dark:to-slate-800"
      data-testid={`tournament-podium-${tournament.id}`}
    >
      <div className="flex items-center gap-1.5 px-3 pt-2.5 pb-1">
        <span className="text-sm">🏆</span>
        <span className="text-xs font-black text-amber-700 dark:text-amber-400 tracking-wide">הזוכים</span>
      </div>
      <div className="px-3 pb-2.5 space-y-1">
        {tournament.podium.slice(0, 3).map((p) => (
          <div key={p.position} className="flex items-center gap-2" data-testid={`podium-pos-${p.position}-${tournament.id}`}>
            <span className="text-base leading-none">{MEDALS[p.position]}</span>
            <span className={`text-sm truncate ${p.position === 1 ? 'font-black text-gray-900 dark:text-white' : 'font-semibold text-gray-600 dark:text-gray-300'}`}>
              {p.name}
            </span>
            <span className="mr-auto text-[10px] text-amber-600/70 dark:text-amber-400/70 font-bold whitespace-nowrap">{LABELS[p.position]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
